function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.414 12L18.243 9.172C18.4306 8.98436 18.5361 8.72986 18.5361 8.4645C18.5361 8.19914 18.4306 7.94464 18.243 7.757C18.0554 7.56936 17.8009 7.46394 17.5355 7.46394C17.2701 7.46394 17.0156 7.56936 16.828 7.757L14 10.586L11.172 7.757C10.9844 7.56936 10.7299 7.46394 10.4645 7.46394C10.1991 7.46394 9.94464 7.56936 9.757 7.757C9.56936 7.94464 9.46394 8.19914 9.46394 8.4645C9.46394 8.72986 9.56936 8.98436 9.757 9.172L12.586 12L9.757 14.828C9.56936 15.0156 9.46394 15.2701 9.46394 15.5355C9.46394 15.8009 9.56936 16.0554 9.757 16.243C9.94464 16.4306 10.1991 16.5361 10.4645 16.5361C10.7299 16.5361 10.9844 16.4306 11.172 16.243L14 13.414L16.828 16.243C17.0156 16.4306 17.2701 16.5361 17.5355 16.5361C17.8009 16.5361 18.0554 16.4306 18.243 16.243C18.4306 16.0554 18.5361 15.8009 18.5361 15.5355C18.5361 15.2701 18.4306 15.0156 18.243 14.828L15.414 12ZM14 22C8.477 22 4 17.523 4 12C4 6.477 8.477 2 14 2C19.523 2 24 6.477 24 12C24 17.523 19.523 22 14 22Z",
  fill: "#2B2828"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgIcDeleteImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteImage);
export default ForwardRef;